import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../services/api";
import AdminLayout from "../../components/admin/Layout/AdminLayout";
import { FaCheckSquare, FaEdit, FaEye, FaEyeSlash, FaTrash } from "react-icons/fa";

export default function AdminBlogs() {

  const [blogs, setBlogs] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  const fetchBlogs = async () => {
    try {
      const res = await api.get("/blogs/admin/all");
      setBlogs(res.data);
      setFiltered(res.data);
    } catch (err) {
      console.error("BLOG FETCH ERROR:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  // SEARCH + FILTER
  useEffect(() => {

    let result = blogs;

    if (search) {
      result = result.filter((b) =>
        b.title.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (statusFilter !== "all") {
      result = result.filter((b) => b.status === statusFilter);
    }

    setFiltered(result);

  }, [search, statusFilter, blogs]);

  // DELETE BLOG
  const handleDelete = async (id) => {

    const confirmDelete = window.confirm("Delete this blog permanently?");
    if (!confirmDelete) return;

    try {

      await api.delete(`/blogs/admin/${id}`);

      const updated = blogs.filter((b) => b._id !== id);
      setBlogs(updated);

    } catch (err) {
      console.error(err);
      alert("Failed to delete blog");
    }
  };

  // TOGGLE STATUS
  const toggleStatus = async (blog) => {

    try {

      const newStatus = blog.status === "published" ? "draft" : "published";

      const res = await api.put(`/blogs/admin/${blog._id}`, {
        status: newStatus,
      });

      setBlogs((prev) =>
        prev.map((b) => (b._id === blog._id ? res.data : b))
      );

    } catch (err) {
      console.error(err);
      alert("Failed to update blog");
    }
  };

  // STATS
  const total = blogs.length;
  const published = blogs.filter((b) => b.status === "published").length;
  const drafts = blogs.filter((b) => b.status === "draft").length;

  return (

    <AdminLayout>

      <div className="container-fluid">

        {/* HEADER */}

        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="fw-bold">Blog Management</h2>

          <Link to="/admin/blog/create" className="btn btn-primary">
            + Create Blog
          </Link>
        </div>

        {/* STATS */}

        <div className="row mb-4">

          <div className="col-md-4">
            <div className="card shadow-sm">
              <div className="card-body">
                <h6>Total Blogs</h6>
                <h3>{total}</h3>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card shadow-sm">
              <div className="card-body">
                <h6>Published</h6>
                <h3 className="text-success">{published}</h3>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card shadow-sm">
              <div className="card-body">
                <h6>Drafts</h6>
                <h3 className="text-secondary">{drafts}</h3>
              </div>
            </div>
          </div>

        </div>

        {/* SEARCH + FILTER */}

        <div className="card shadow-sm mb-3">

          <div className="card-body d-flex gap-3 flex-wrap">

            <input
              className="form-control"
              style={{ maxWidth: 300 }}
              placeholder="Search blogs..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <select
              className="form-select"
              style={{ maxWidth: 200 }}
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="all">All Status</option>
              <option value="published">Published</option>
              <option value="draft">Draft</option>
            </select>

          </div>

        </div>

        {/* TABLE */}

        <div className="card shadow-sm">

          <div className="card-body">

            {loading ? (
              <p>Loading blogs...</p>
            ) : filtered.length === 0 ? (
              <p>No blog posts found.</p>
            ) : (

              <div className="table-responsive">

                <table className="table table-hover align-middle">

                  <thead>
                    <tr>
                      <th>Image</th>
                      <th>Title</th>
                      <th>Category</th>
                      <th>Status</th>
                      <th>Views</th>
                      <th>Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>

                  <tbody>

                    {filtered.map((blog) => (

                      <tr key={blog._id} >

                        {/* IMAGE */}

                        <td>
                          {blog.coverImage && (
                            <img
                              src={blog.coverImage}
                              alt=""
                              style={{
                                width: 90,
                                height: 50,
                                objectFit: "cover",
                                borderRadius: 6
                              }}
                            />
                          )}
                        </td>

                        {/* TITLE */}

                        <td>
                        <strong
                            title={blog.title}
                            style={{
                            maxWidth: "200px",
                            display: "inline-block",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                            }}
                        >
                            {blog.title}
                        </strong>
                        </td>

                        {/* CATEGORY */}

                        <td>
                          {blog.category?.name || "Uncategorized"}
                        </td>

                        {/* STATUS */}

                        <td>
                          <span
                            className={`badge ${
                              blog.status === "published"
                                ? "bg-success"
                                : "bg-secondary"
                            }`}
                          >
                            {blog.status}
                          </span>
                        </td>

                        {/* VIEWS */}

                        <td>
                          {blog.views || 0}
                        </td>

                        {/* DATE */}

                        <td>
                          {new Date(blog.createdAt).toLocaleDateString()}
                        </td>

                        {/* ACTIONS */}

<td>
  <div className="d-flex gap-2">

    <Link
      to={`/blog/article/${blog.slug}`}
      className="btn btn-sm btn-outline-dark"
    >
      <FaEye />
    </Link>

    <Link
      to={`/admin/blog/edit/${blog._id}`}
      className="btn btn-sm btn-outline-primary"
    >
      <FaEdit/>
    </Link>

<button
  className={`btn btn-sm ${
    blog.status === "published"
      ? "btn-outline-warning"
      : "btn-outline-success"
  }`}
  onClick={() => toggleStatus(blog)}
>
  {blog.status === "published" ? (
    <>
      <FaEyeSlash className="me-1" />
    </>
  ) : (
    <>
      <FaCheckSquare className="me-1" />
    </>
  )}
</button>

    <button
      className="btn btn-sm btn-outline-danger"
      onClick={() => handleDelete(blog._id)}
    >
      <FaTrash />
    </button>

  </div>
</td>

                      </tr>

                    ))}

                  </tbody>

                </table>

              </div>

            )}

          </div>

        </div>

      </div>

    </AdminLayout>

  );
}